import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { Skeleton } from 'antd';
import { SelectValue } from 'antd/lib/select';

import { CustomSelect } from '@share/components';
import { WalletSearchSlider } from '@components';
import { GetLifeStyleStores } from '@utils';
import { IAccount, ILocation } from '@share/common-types';

import { SelectedFiltersHeader } from '../selected-filters-header';

export interface IResultWrapperHotelsTopSectionsProps {
  showFilterHeaderSection: boolean;
  isNewTemplate: boolean;
  displaySelectedFiltersHeader: boolean;
  isVacationRentals: boolean;
  location: ILocation | null | undefined;
  account: IAccount | null | undefined;
  isAllInclusive: boolean;
  isCapital: boolean;
  isCapitalAgent: boolean;
  isMobile: boolean;
  loadingQuick: boolean;
  totalFilteredHotelsTotal: number;
  isSessionExpired: boolean;
  loadingFilter: boolean;
  lifeStyle: string | null | undefined;
  sortBy: SelectValue;
  onFiltersOrSortChange: (isStoreChange?: boolean) => void;
  onLifeStyleChange: (value: SelectValue) => void;
  onSortChange: (value: SelectValue) => void;
  sortOptions: any[];
  homesFilter: ReactNode;
  showWalletSection: boolean;
  selectedClientCash: number | undefined;
  onSelectClientCash: (selectedSearchClientCash: number | null | undefined) => void;
}

/**
 * Hotel search results: the two `result-wrapper__top-section` blocks (filters/sort row + wallet slider).
 */
export function ResultWrapperHotelsTopSections(props: IResultWrapperHotelsTopSectionsProps): React.ReactElement {
  const {
    showFilterHeaderSection,
    isNewTemplate,
    displaySelectedFiltersHeader,
    isVacationRentals,
    location,
    account,
    isAllInclusive,
    isCapital,
    isCapitalAgent,
    isMobile,
    loadingQuick,
    totalFilteredHotelsTotal,
    isSessionExpired,
    loadingFilter,
    lifeStyle,
    sortBy,
    onFiltersOrSortChange,
    onLifeStyleChange,
    onSortChange,
    sortOptions,
    homesFilter,
    showWalletSection,
    selectedClientCash,
    onSelectClientCash,
  } = props;

  return (
    <>
      {showFilterHeaderSection && (
        <div className="result-wrapper__top-section">
          <div className="col-12">
            <div className="row">
              {location?.type !== 'Hotel' && !isVacationRentals && !account?.forceDisableVacationRentals && !isAllInclusive && !account?.isSundance && (
                <div className={account?.isNewTemplate ? 'col-md-12 col-sm-8' : 'col-md-5 col-sm-8'}>{homesFilter}</div>
              )}

              {isNewTemplate && displaySelectedFiltersHeader && (
                <div className="col-md-12 col-sm-8">
                  <SelectedFiltersHeader
                    isVacationRentals={isVacationRentals}
                    onFiltersOrSortChange={onFiltersOrSortChange}
                  />
                </div>
              )}

              <div
                className={
                  account?.isNewTemplate
                    ? isCapital && !isCapitalAgent
                      ? 'col-md-6'
                      : 'col-md-9'
                    : location?.type !== 'Hotel' && !isVacationRentals && !account?.forceDisableVacationRentals && !isAllInclusive && !isCapital && !account?.isSundance
                      ? 'text-center col-md-3'
                      : isCapital && !isCapitalAgent && !isMobile
                        ? 'col-md-5'
                        : location?.type !== 'Hotel'
                          ? 'col-md-9'
                          : 'col-md-8'
                }
              >
                {!loadingQuick ? (
                  <p className="result-wrapper__top-header">
                    {((location?.type === 'Hotel' && totalFilteredHotelsTotal) || location?.type !== 'Hotel') && (
                      <FormattedMessage id="properties.found" values={{ count: totalFilteredHotelsTotal }} />
                    )}

                    {location?.type === 'Hotel' && !totalFilteredHotelsTotal && (
                      <FormattedMessage id="properties.found" values={{ count: totalFilteredHotelsTotal }} />
                    )}
                  </p>
                ) : (
                  <Skeleton active title paragraph={false} style={{ marginTop: '15px', width: '90%' }} />
                )}
              </div>

              {isCapital && !isCapitalAgent ? (
                <div className={isMobile ? 'col-md-4 col-sm-4' : 'col-md-3 col-sm-3'}>
                  <div className="result-wrapper__sort-select capital-vacations">
                    {!isNewTemplate && (
                      <span className="result-wrapper__sort-label">
                        <FormattedMessage id="lifestyle.change" />{' '}
                      </span>
                    )}
                    <CustomSelect
                      disabled={isSessionExpired || loadingFilter || loadingQuick}
                      value={lifeStyle as string}
                      onChange={onLifeStyleChange}
                      options={GetLifeStyleStores()}
                    />
                  </div>
                </div>
              ) : null}

              {!isMobile ? (
                <div
                  className={isCapital && !isNewTemplate ? 'col-md-4 col-sm-4' : !isNewTemplate && !isVacationRentals ? 'col-md-4 col-sm-4' : 'col-md-3 col-sm-3'}
                >
                  <div className="result-wrapper__sort-select">
                    {!isNewTemplate && (
                      <span className="result-wrapper__sort-label">
                        <FormattedMessage id="sort.by" />{' '}
                      </span>
                    )}
                    <CustomSelect
                      disabled={isSessionExpired || loadingFilter || loadingQuick}
                      value={sortBy as any}
                      onChange={onSortChange}
                      options={sortOptions}
                    />
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      )}

      {showWalletSection ? (
        <div
          className="result-wrapper__top-section"
          style={{
            backgroundColor: '#FFFFFF',
            marginBottom: '20px',
            borderRadius: isCapital ? '0px' : '5px',
            marginTop: isCapital ? '8px' : '0px',
            minHeight: 'unset',
            border: isCapital ? '3px solid #006098' : '1px solid #D2D2D2',
          }}
        >
          <WalletSearchSlider
            display={true}
            selectedClientCash={selectedClientCash as number}
            onSelectClientCash={onSelectClientCash}
          />
        </div>
      ) : null}
    </>
  );
}
